import MuiButton from "./MuiButton"
import MuiTextField from "./MuiTextField"

const components = {
  MuiButton,
  MuiTextField,
}

export default components
